export const APP_TRANSLATIONS_URL = '/rest-api/fk-rest-textnycklar/public/v2/preliminar-berakning-btp';
